export default "__VITE_PUBLIC_ASSET__5771fb49__"